




















































import Vue from 'vue'

enum Events {
  input = 'input',
  change = 'change',
  decrease = 'decrease',
  increase = 'increase',
  state = 'state'
}

export default Vue.extend({
  name: 'QuantitySelector',
  props: {
    noText: {
      type: Boolean,
      default: false
    },
    center: {
      type: Boolean,
      default: false
    },
    left: {
      type: Boolean,
      default: false
    },
    min: {
      type: [Number, String],
      default: 0
    },
    max: {
      type: [Number, String],
      default: undefined
    },
    index: {
      type: [Number, String],
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: Number,
      required: true
    },
    throttle: {
      type: [Number, String],
      default: 0
    },
    forceUpdate: {
      type: Boolean,
      default: false
    },
    noMesh: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      localValue: this.value,
      throttleTime: 0,
      inputThrottleTimer: null as number | null,
      lastEvent: null as Events.change | Events.decrease | Events.increase | null
    }
  },
  computed: {
    computedMin (): number | undefined {
      const integer = Number(this.min)
      return isNaN(integer) ? undefined : integer
    },
    computedMax (): number | undefined {
      const integer = Number(this.max)
      return isNaN(integer) ? undefined : integer
    }
  },
  watch: {
    value (newValue) {
      this.localValue = newValue
    },
    throttle (newValue) {
      const integer = typeof newValue === 'string' ? parseInt(newValue, 10) : newValue
      this.throttleTime = Math.max(isNaN(integer) ? 0 : integer)
      if (this.throttleTime <= 0 && this.lastEvent) {
        this.updateValue(this.localValue, this.lastEvent)
      }
    },
    forceUpdate (newValue) {
      console.log('force', newValue)
      if (newValue && this.lastEvent) {
        this.updateValue(this.localValue, this.lastEvent)
      }
    }
  },
  created () {
    const integer = typeof this.throttle === 'string' ? parseInt(this.throttle, 10) : this.throttle
    this.throttleTime = Math.max(isNaN(integer) ? 0 : integer)
  },
  mounted () {
    // Set up destroy handler
    this.$on('hook:beforeDestroy', this.clearThrottle)
  },
  methods: {
    clearThrottle () {
      if (this.inputThrottleTimer === null) return
      clearTimeout(this.inputThrottleTimer)
      this.inputThrottleTimer = null
    },
    updateValue (
      value: number,
      event: Events.change | Events.decrease | Events.increase
    ) {
      if (this.throttleTime > 0 && !this.forceUpdate) {
        this.lastEvent = event
        if (this.inputThrottleTimer) {
          this.clearThrottle()
        } else {
          this.$emit(Events.state, 'throttling')
        }
        this.inputThrottleTimer = setTimeout(() => {
          this.$emit(Events.input, this.localValue, this.index)
          this.$emit(event, this.localValue, this.index)
          this.$emit(Events.state, 'idle')
          this.clearThrottle()
          this.lastEvent = null
        }, this.throttleTime)
      } else {
        // Clear the throttle timer
        if (this.inputThrottleTimer) {
          this.clearThrottle()
        }
        this.$emit(Events.input, this.localValue, this.index)
        this.$emit(event, this.localValue, this.index)
        this.$emit(Events.state, 'idle')
      }
    },
    onDecreaseQuantityClicked () {
      this.setValueInBoundary(this.localValue - 1)
      this.updateValue(this.localValue, Events.decrease)
    },
    onIncreaseQuantityClicked () {
      this.setValueInBoundary(this.localValue + 1)
      this.updateValue(this.localValue, Events.increase)
    },
    onInputQuantityChanged () {
      this.setValueInBoundary(this.localValue)
      this.updateValue(this.localValue, Events.change)
    },
    setValueInBoundary (targetValue: number) {
      const max = this.computedMax
      const min = this.computedMin
      if (this.noMesh) {
        this.localValue = 1
        this.$bvModal.msgBoxOk('似顏繪產品不可以修改份數，若要加購無框畫實體商品，請您重新下單到購物車，填單時記得設定您要的無框畫數量。', {
          centered: true,
          footerClass: 'msgbox-ok-footer',
          okTitle: '確定'
        })
      } else if (max && targetValue > max) {
        this.localValue = max
        this.$bvModal.msgBoxOk('數量超過商品剩餘數量', {
          centered: true,
          footerClass: 'msgbox-ok-footer',
          okTitle: '確定'
        })
      } else if (min && targetValue < min) {
        this.localValue = min
      } else {
        this.localValue = targetValue
      }
    }
  }
})
